import {Component, Input, ViewChild, inject, AfterViewInit} from '@angular/core';
import {LoginComponent} from '../../core/components/login/login.component';
import {TranslationService} from '../../core/services/translation.service';
import {ConfigService} from "../../core/services/config.service";
import {LoginService} from "../../core/components/login/login.service";
import {CssPropertiesEnum} from "../../core/models/css-properties.enum";
import {RedirectService} from "../../data/services/redirect.service";
import {ActivatedRoute, RouterLink, RouterLinkActive} from "@angular/router";
import {LandingPage} from "../../data/models/landing-page.model";
import {LandingPageService} from "../../data/services/landing-page.service";

import {NgbCollapse} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  imports: [
    NgbCollapse,
    RouterLink,
    RouterLinkActive,
    LoginComponent
],
  standalone: true
})
export class NavigationComponent {
  translationService = inject(TranslationService);
  private configService = inject(ConfigService);
  private loginService = inject(LoginService);
  redirectService = inject(RedirectService);
  private route = inject(ActivatedRoute);
  landingPageService = inject(LandingPageService);

  @ViewChild('login') loginComponent: LoginComponent;
  isAuthenticated: boolean = false;
  CssPropertiesEnum = CssPropertiesEnum;
  activeRoute:string = null;
  @Input() horizontalNavigation: boolean = true;

  links: LandingPage[];
  filteredLinks: LandingPage[];
  public isCollapsed = true;

  constructor() {
    this.loginService.getAuthData().subscribe((authData) => {
      this.isAuthenticated = !!authData;
      this.buildLinkList();
    });

    this.route.url.subscribe(url => {
      this.activeRoute = '';
    });

    this.landingPageService.getLandingPages().subscribe(pages => {
      if(pages && pages.length > 0) {
        this.links = pages;
        this.buildLinkList();
      }
    });
  }

  buildLinkList() {
    const newLinkList = [];
    if(this.links) {
      this.links.forEach(link => {
        const showBeforeLogin = link.showBeforeLogin && !this.isAuthenticated;
        const showAfterLogin = link.showAfterLogin && this.isAuthenticated;
        if (showBeforeLogin || showAfterLogin) {
          newLinkList.push(link);
        }
      });
    }
    this.filteredLinks = newLinkList;
  }

  onClickEvent(): void{
    this.loginComponent.onClickEvent();
  }

  navigateToExternRoute(link: LandingPage) {
    this.redirectService.redirect(link.externLink, true);
  }
}
